import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox';
import { getQueryString } from '../../../utils/params';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';
import { BannerOurOffice, BreadcrumbServicedOffice, MenuServicedOffice } from '../common';
import { getGalleryInfo, getOfficeInfo, getVideoInfo } from '../servicedOffice.api';
import { useParams } from 'react-router-dom';

function ServicedOfficeGalleryComponent() {
  const { t } = useTranslation();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { language } = useParams();
  const [galleryInfo, setGalleryInfo] = useState();
  const [videoInfo, setVideoInfo] = useState();
  const [videoUrl, setVideoUrl] = useState('');
  const [officeId, setOfficeId] = useState(0);

  const options = {
    settings: {
      disableWheelControls: true,
    },

    buttons: {
      backgroundColor: 'rgba(30,30,36,0.8)',
      iconColor: 'rgba(255, 255, 255, 0.8)',
      iconPadding: '10px',
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: false,
      showNextButton: true,
      showPrevButton: true,
      showThumbnailsButton: false,
      size: '43px',
    },

    thumbnails: {
      showThumbnails: false,
    },
  };

  useEffect(() => {
    showLoader();
    getOfficeInfo(getQueryString({ language })).then(res => {
      if (res) {
        setOfficeId(res[0]?.id);
      }
    });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (officeId !== 0) {
      getGalleryInfo(getQueryString({ language, officeId })).then(res => {
        if (res) {
          setGalleryInfo(res);
        }
      });
      getVideoInfo(getQueryString({ language, officeId })).then(res => {
        if (res) {
          setVideoInfo(res[0]);
          const _url = res[0]?.videoUrl.replace('watch?v=', 'embed/');
          setVideoUrl(_url);
        }
      });
      hideLoader();
    }
    //eslint-disable-next-line
  }, [officeId]);

  return (
    <>
      <BreadcrumbServicedOffice />
      <BannerOurOffice />
      <MenuServicedOffice />
      <div className="container" id="servicedOfficeGallery">
        <div className="gallery-title-1">{t('servicedOffice.label_photoGallery')}</div>
        {galleryInfo
          ? galleryInfo.map((item, index) => {
              return (
                <div key={index}>
                  <div className="gallery-title-2">{item.title}</div>
                  <SimpleReactLightbox>
                    <SRLWrapper options={options}>
                      <div className="row">
                        {item.images.map((item2, index2) => {
                          return (
                            <div className="col-12 col-sm-4 our-office-gallery__media pb-4" key={index2}>
                              <img
                                className="our-office-gallery__image"
                                src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item2.imageUrl}`}
                                alt="gallery"
                              />
                            </div>
                          );
                        })}
                      </div>
                    </SRLWrapper>
                  </SimpleReactLightbox>
                </div>
              );
            })
          : ''}

        {videoInfo ? (
          <>
            <div className="gallery-title-2">{videoInfo.name}</div>
            <div className="video-responsive">
              <iframe
                width="100%"
                height="715.51px"
                src={videoUrl}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded youtube"
              />
            </div>
          </>
        ) : (
          ''
        )}
      </div>
      {loader}
    </>
  );
}

export default ServicedOfficeGalleryComponent;
